<template>
  <!-- <span class="p-float-label">
        <label for="inputNameId">اندازه </label>
    </span> -->
  <!-- <Divider align="center">
          <div class="inline-flex align-items-center"> -->
  <h5 class="mb-0">مشاهده ویژگی ها:</h5>
  <!-- </div>
      </Divider> -->
  <div class="grid p-fluid mt-3">
    <div class="field col-12 md:col-4">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <span>متر</span>
        </span>
        <InputText
          v-model="form.totalAreaByMeters"
          @blur="v$.form.totalAreaByMeters.$touch"
          @input="v$.form.totalAreaByMeters.$touch"
          type="Number"
          placeholder="مساحت سازه"
          mode="decimal"
          :useGrouping="false"
          :class="{
            'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.totalAreaByMeters.$error,
          }"
        />
      </div>
      <small v-if="v$.form.totalAreaByMeters.required.$invalid && v$.form.totalAreaByMeters.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.totalAreaByMeters.required.$message }}
      </small>
    </div>
    <div class="field col-12 md:col-4">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <span>طبقه</span>
        </span>
        <InputText
          v-model="form.numberOfFloors"
          @blur="v$.form.numberOfFloors.$touch"
          @input="v$.form.numberOfFloors.$touch"
          type="Number"
          placeholder="تعداد طبقات"
          mode="decimal"
          :min="0"
          :max="40"
          :useGrouping="false"
          :class="{
            'border-red-500 hover:border-red-500 focus:shadow-none': v$.form.numberOfFloors.$error,
          }"
        />
      </div>
      <small v-if="v$.form.numberOfFloors.required.$invalid && v$.form.numberOfFloors.$dirty" ref="password_error_message" class="text-red-500">
        {{ v$.form.numberOfFloors.required.$message }}
      </small>
    </div>
    <!-- TODO: On development -->
    <div v-for="(collection, index) in collections.featureCollections" :key="index" class="field col-12">
      <!-- <div class="flex align-content-center">
          <img v-lazy :src="'https://api.koome.net/' + collection.icon" width="20" />
          <span class="mx-1">{{collection.title}}</span>
          </div> -->
      <Divider type="dashed" align="start">
        <div class="flex align-content-center">
          <img v-lazy :src="'https://api.koome.net/' + collection.icon" width="20" />
          <span class="mx-2">{{ collection.title }}</span>
        </div>
      </Divider>
      <div class="grid p-fluid mt-3">
        <div v-for="(feature, index) in collection.features" :key="index" class="field col-12 md:col-3">
          <div class="card h-full">
            <div class="flex flex-row justify-content-between">
              <div class="flex flex-row">
                <img v-lazy :src="'https://api.koome.net/' + feature.icon" width="20" />
                <span class="mx-2">{{ feature.title || "ویژگی" }}</span>
              </div>
              <!-- <Checkbox :value="feature" size="small" v-model="selectedFeatures" /> -->
            </div>
            <div class="mt-2">
              <span>نوع ویژگی:</span>
              <small class="mx-1">{{ featureType(feature) }}</small>
            </div>
            <div v-if="feature.featureValueType !== ''" class="field my-3">
              <h6>مقدار اولیه:</h6>
              <div v-if="feature.featureValueType === 0" class="field-checkbox mb-0">
                <Checkbox v-model="feature.value" :binary="true" />
                <label for="checkOption1" class="mr-2">{{ feature.value ? "دارد" : "ندارد" }}</label>
              </div>
              <InputText v-else-if="feature.featureValueType === 1" type="text" v-model="feature.value" />
              <InputNumber v-else id="numberDefaultValue" v-model="feature.value" :useGrouping="false" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field col-12 flex flex-row align-items-center justify-content-end">
      <div class="md:w-2">
        <Button :disabled="!form.totalAreaByMeters || !form.numberOfFloors" icon="pi pi-check" loadingIcon="pi pi-spinner" :loading="loading['create']" @click="createPlaceFeature" class="p-button p-button-primary w-full mr-2 mb-2">
          <small>ثبت ویژگی ها</small>
        </Button>
      </div>
    </div>
    <div class="field col-12">
      <slot name="specifics"></slot>
    </div>
  </div>
</template>

<script>
import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
export default {
  name: "placeFeatures",
  setup: () => ({ v$: useVuelidate() }),
  props: {
    collections: {
      type: Object,
      default: null,
    },
    placeId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        totalAreaByMeters: 0,
        numberOfFloors: 0,
        features: [],
      },
      featureValueTypes: [
        { value: "چک باکس", id: 0 },
        { value: "متنی", id: 1 },
        { value: "عددی", id: 2 },
      ],
      loading: {
        create: false,
      },
      selectedFeatures: [],
    };
  },
  watch: {
    "$props.collections": {
      handler: (val) => {
        val;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    featureType() {
      return (item) => (item.featureValueType === 0 ? "چک باکس" : item.featureValueType === 1 ? "متنی" : "عددی");
    },
  },
  methods: {
    //******* Api methods begin *******//
    async createPlaceFeature() {
      this.loading["create"] = true;
      let features = [];
      this.collections.featureCollections.forEach(function (col) {
        col.features.forEach(function (f) {
          features.push({ featureId: f.featureId, value: f.value });
        });
      });
      this.form.features = [...features];
      const { status, data } = await this.axios({ method: "put", url: `Place/${this.placeId}/features`, data: this.form });
      if (status === 200) {
        this.$emit("create-event");
        this.showToast(status);
      } else {
        this.showToast(status.errors);
      }
      // debugger
      this.loading["create"] = false;
    },
    //******* Api methods end *******//
  },
  mounted() {
    if (!!this.collections) {
      this.form.totalAreaByMeters = this.collections.totalAreaByMeters;
      this.form.numberOfFloors = this.collections.numberOfFloors;
    }
  },
  validations() {
    return {
      form: {
        totalAreaByMeters: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
        numberOfFloors: {
          required: helpers.withMessage("این فیلد الزامی است", required),
          $dirty: false,
        },
      },
    };
  },
};
</script>
